import React from "react";

function SummarySection({ children }) {
  return (
    <div className="container bgCustomList mt-5 my-3 pt-5 py-5">
      <div className="row">
        <div className="container">{children}</div>
      </div>
    </div>
  );
}

export default SummarySection;
